import { isObject } from 'lodash'
import Decorator from './decorator'
import moment from 'moment'
import accounting from 'accounting'

export default class PaymentDecorator extends Decorator {
  /**
   * The company name of the user this invoice belongs to.
   */
  carrierName () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.company_name
    }

    return '–'
  }

  /**
   * The carrier's address.
   */
  carrierAddress () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.address_line_1
    }
  }

  /**
   * The carrier's suburb.
   */
  carrierSuburb () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.suburb
    }
  }

  /**
   * The carrier's state.
   */
  carrierState () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.state
    }
  }

  /**
   * The carrier's postcode.
   */
  carrierPostcode () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.postcode
    }
  }

  /**
   * The carrier's postcode.
   */
  carrierAbn () {
    if (isObject(this.carrier)) {
      return this.decorated.carrier.profile.company_abn
    }

    return '–'
  }

  /**
   * Payments status.
   *
   * @return string
   */
  status () {
    if (this.decorated.status === 'invoice') {
      return 'Invoice'
    } else if (this.decorated.status === 'uploaded') {
      return 'Uploaded'
    } else if (this.decorated.status === 'paid') {
      return 'Paid'
    }
  }

  /**
   * Total GST being paid.
   */
  totalGst () {
    if (!this.decorated.total_including_gst) {
      return '–'
    }

    return accounting.formatMoney(this.decorated.total_including_gst - this.decorated.total_excluding_gst)
  }

  /**
   * The total cost of the invoice without GST.
   */
  totalWithoutGst () {
    if (!this.decorated.total_excluding_gst) {
      return '–'
    }

    return accounting.formatMoney(this.decorated.total_excluding_gst)
  }

  /**
   * The amount that has been paid
   */
  paid () {
    if (!this.decorated.amount_paid) {
      return accounting.formatMoney(0)
    }

    return accounting.formatMoney(this.decorated.amount_paid)
  }

  /**
   * The amount that still needs to be paid
   */
  remaining () {
    if (!this.decorated.total_including_gst) {
      return accounting.formatMoney(0)
    }

    return accounting.formatMoney(this.decorated.total_including_gst - this.decorated.amount_paid)
  }

  /**
   * The total cost including GST.
   */
  totalWithGst () {
    if (!this.decorated.total_including_gst) {
      return accounting.formatMoney(0)
    }

    return accounting.formatMoney(this.decorated.total_including_gst)
  }

  /**
   * The due date.
   *
   * @return string
   */
  dueDate () {
    if (!this.decorated.due_date) {
      return '–'
    }

    return this.decorated.due_date
  }

  /**
   * The due date in an alternative format.
   *
   * @return string
   */
  dueDateAlternative () {
    if (!this.decorated.due_date) {
      return '–'
    }

    return moment(this.decorated.due_date, 'DD/MM/YYYY').format('DD MMMM YYYY')
  }

  /**
   * The created at date.
   *
   * @return string
   */
  createdDate () {
    if (!this.decorated.created_at) {
      return '–'
    }

    return this.decorated.created_at
  }

  /**
   * The created date in an alternative format.
   *
   * @return string
   */
  createdDateAlternative () {
    if (!this.decorated.created_at) {
      return '–'
    }

    return moment(this.decorated.created_at, 'DD/MM/YYYY').format('DD MMMM YYYY')
  }

  /**
   * The date it was paid .
   *
   * @return string
   */
  paidDate () {
    if (!this.decorated.paid_date) {
      return '–'
    }

    return this.decorated.paid_date
  }

  /**
   * The paid date in an alternative format.
   *
   * @return string
   */
  paidDateAlternative () {
    if (!this.decorated.paid_date) {
      return '–'
    }

    return moment(this.decorated.paid_date, 'DD/MM/YYYY').format('DD MMMM YYYY')
  }

  /**
   * Determine if the payment has been paid.
   *
   * @return boolean
   */
  isPaid () {
    return this.decorated.status === 'paid'
  }

  /**
   * Determine if the payment has some payments against it.
   *
   * @return boolean
   */
  hasSomePayments () {
    return this.decorated.amount_paid > 0
  }
}



// WEBPACK FOOTER //
// ./src/decorators/payment.js